import React, { Component, useState, useEffect } from 'react'
import logo from '../images/LOGO-transparent.png'
import fire from '../auth/fire'
import { Redirect } from 'react-router-dom'
import Loading from '../UiComponents/Loading'
import "react-notifications-component/dist/theme.css";
import { store } from 'react-notifications-component'

const SignUp = () => {
    const [currentUser, setCurrentUser] = useState(null);
    const [emailError, setEmailError] = useState("")
    const [passwordError, setPasswordError] = useState("")
    const [loading, setLoading] = useState(false)

    const notifyPopup = () => {
        store.addNotification({
            title: "Error!",
            message: "Password Don't Match with Confirm Password",
            type: "danger",
            background: "pink",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 3000,
                onScreen: true,
            },
        });
    };
    const handleSubmit = (e) => {
        setLoading(true)
        e.preventDefault();
        const { email, password, cfrm_password } = e.target.elements;
        if (password.value == cfrm_password.value) {
            fire.auth().createUserWithEmailAndPassword(email.value, password.value)
                .then((res) => {
                    setCurrentUser(true)
                    setLoading(false)
                    console.log("response", res);
                }).catch((error) => {
                    switch (error) {
                        case "auth/email-already-in-use":
                        case "auth/invalid-email":
                            setEmailError(error.message);
                            setLoading(false)
                            break;
                        case "auth/weak-password":
                            setPasswordError(error.message)
                            setLoading(false)

                            break;
                    }
                })
        } else {
            notifyPopup()
            setLoading(false)
            return
        }

    }
    if (currentUser) {

        return <Redirect to="/" />;
    }
    return (
        <>
            <div className="container-fluid">
                <div className="container mt-5">
                    <div className="row">
                        <div className="col-10 mx-auto ">
                            <div className="row">
                                <div className="col-lg-6 col-sm-12 col-xs-12 col-md-6 ">
                                    <div>
                                        <img src={logo} alt="image" className="img-fluid" />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-sm-12 col-xs-12 col-md-6 ">
                                    <div className="d-flex flex-column align-content-center  ">
                                        <div className="text-center my-3">
                                            <div>
                                                <h1>
                                                    Sign Up
                                        </h1>
                                            </div>
                                            <div>
                                                <form id="contact-form"
                                                    className="form m-3 border border-dark p-3 rounded" role="form" onSubmit={handleSubmit}>
                                                    <div class="form-group">
                                                        <label className="form-label" for="username">Username</label>
                                                        <input type="text" className="form-control" id="username" name="username" placeholder="Username" tabindex="1"

                                                            required />
                                                    </div>
                                                    <div class="form-group">
                                                        <label className="form-label" for="email">Email</label>
                                                        <input type="email" className="form-control" id="email" name="email" placeholder="Email" tabindex="1" required
                                                        />
                                                        <p className="text-danger">{emailError}</p>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="form-label" for="message">Password</label>
                                                        <input type="password" name="password" className="form-control" id="password" placeholder="Shh! it's a secret" tabindex="4" required

                                                        />
                                                        <p className="text-danger">{passwordError}</p>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="form-label" for="cfrm_password">Confirm Password</label>
                                                        <input type="password" name="cfrm_password" className="form-control" id="cfrm_password" placeholder="confirm secret" tabindex="4" required></input>
                                                    </div>
                                                    <div className="text-center">
                                                        {loading ? <Loading style={"text-center"} /> : <button type="submit" className="btn btn-explore bg-dark text-white btn-block">
                                                            SignUp</button>}
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    window.scrollTo(0, 0)
                }
            </div></>

    )
};

export default SignUp;
